import { createStore } from 'vuex'
//------------------------------------------------------------
const CONFIG = { expires: 1, secure: true, httpOnly: true }
//------------------------------------------------------------
const store = createStore({
  state:{
      token: localStorage.getItem('token') || null,
      // token_iat: localStorage.getItem('token_iat') || null,
      token_end: localStorage.getItem('token_end') || null,
      id: localStorage.getItem('id') || '',
      name: localStorage.getItem('name') || '',
      type: localStorage.getItem('type') || '',
      acl: JSON.parse(localStorage.getItem('acl') || '[]') || [],
  },
  getters:{
    isAuth: state => !!state.token,
    isAdmin: state => ['super', 'admin', 'advanced user'].includes(state.type),
    isSuper: state => state.type == 'super',
    sessionTime: state => (state.token_end - Date.now()),
    access: (state) => (ops) => {
      if(state.type == 'super') return true;
      ops = Array.isArray(ops) ? ops : [ops];
      return state.acl.some(x => ops.some(s => x.includes(s)))
      // return state.acl.some((x)=>x.includes(code))  
    }
  },
  mutations: {
    userData (state, {token, token_end, id, name, type, acl}) {
      state.token = token;
      state.token_end = token_end;
      state.id = id;
      state.name = name;
      state.type = type;
      state.acl = acl;
      localStorage.setItem('token', token, CONFIG);
      // localStorage.setItem('token_iat', token_iat, CONFIG);
      localStorage.setItem('token_end', token_end, CONFIG);
      localStorage.setItem('id', id, CONFIG);
      localStorage.setItem('name', name, CONFIG);
      localStorage.setItem('type', type, CONFIG);
      localStorage.setItem('acl', JSON.stringify(acl), CONFIG);
    },
    userName (state, {name}) {
      state.name = name;
      localStorage.setItem('name', name, CONFIG);
    },
    clearAll(state) {
      state.token = null;
      // state.token_iat = null;
      state.token_end = null;
      state.id = '';
      state.name = '';
      state.acl = [];
      localStorage.removeItem('token');
      // localStorage.removeItem('token_iat');
      localStorage.removeItem('token_end');
      localStorage.removeItem('id');
      localStorage.removeItem('name');
      localStorage.removeItem('type');
      localStorage.removeItem('acl');
    },
  },
  actions:{
    async userData({commit}, data){
      await commit('userData', data);
    },
    userName({commit}, data){
      commit('userName', data);
    },
    clearAll({commit}){
      commit('clearAll');
    }
  }
})
export default store;
